/*
 * @Author: Teemo Ding
 * @Date: 2021-09-14 15:29:11
 * @LastEditTime: 2022-06-10 14:26:42
 * @LastEditors: Json Chen
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelDomain/List/index.tsx
 */
import { Skeleton } from '@/src/components/Antd';
import CommonHeader from '@/src/components/CommonHeader';
import RouteBlock from '@/src/constrains/RouterBlock/RouterBlock';
import useBreadCrumbData from '@/src/pages/SalesCannelVersion/Hooks/useBreadCrumbData';
import {
  request_domainsList,
  save_missingPageRedirection,
  save_redirection,
  save_websitemode,
} from '@/src/request/salesChannel/setting/domain';
import {
  isUserValid,
  salesChannelResourceNameGenerator,
} from '@/src/tools/getUserInfo';
import { randomNumber } from '@/src/tools/helper';
import { getI18nFromGeneral } from '@/src/tools/tools';
import { EnumStatus, RequestType } from '@/src/types/common/domain';
import { msg } from '@/src/tools/message';
import {
  EPermissionSource,
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
} from '@/src/types/common/resources';
import { Form } from 'antd';
import { get } from 'lodash';
import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router';
import { useDispatch } from 'react-redux';
import { fetchSalesChannel } from '@/src/constrains/SalesChannelHOC/slice';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import Redirection from './CustomRedirection';
import Domains from './Domains';
import MissingPageRedirection from './MissingPageRedirection';
import WebsiteMode from './WebsiteMode';
import css from './css.module.less';

const permissions = (uuid: string) => {
  const view_domain_and_status = isUserValid({
    source: EPermissionSource.salesChannel,
    resourcesGroup: [
      salesChannelResourceNameGenerator({
        category: EnumCategory.SalesChannelSettings,
        subCategory: EnumSubCategory.ChannelDomainAndStatus,
        operation: EnumOperation.view_domain_and_status,
        uuid,
      }),
    ],
  });
  const edit_domain_and_status = isUserValid({
    source: EPermissionSource.salesChannel,
    resourcesGroup: [
      salesChannelResourceNameGenerator({
        category: EnumCategory.SalesChannelSettings,
        subCategory: EnumSubCategory.ChannelDomainAndStatus,
        operation: EnumOperation.edit_domain_and_status,
        uuid,
      }),
    ],
  });

  return {
    view_domain_and_status,
    edit_domain_and_status,
  };
};

const SalesChannelDomain = () => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [hasModified, setHasModified] = useState(false);
  const params: any = useParams();
  const history = useHistory();
  const [form] = Form.useForm();
  const [redirectForm] = Form.useForm();
  const [SisterSalesChannelForm] = Form.useForm();
  const { uuid: salesChannelUuid } = params;
  const { edit_domain_and_status, view_domain_and_status } =
    permissions(salesChannelUuid);
  const [formData, setFormData] = useState<any>({});

  const currentDomain =
    get(
      (get(formData, 'domains') || []).find(
        (o) => o.status == EnumStatus.Connected,
      ),
      'domain',
    ) || '';

  const [isEditing, setIsEditing] = React.useState(false);

  const [
    missingPageRedirectionSettingUuid,
    setMissingPageRedirectionSettingUuid,
  ] = useState('');
  const [redirectSettingUuid, setRedirectSettingUuid] = useState('');
  const [sisterSalesChannelList, setSisterSalesChannelList] = useState([]);

  const { loading: breadCrumbLoading, breadcrumbData } = useBreadCrumbData({
    lastSecond: getI18n('general.sider.settings'),
    lastOne: getI18n('salesChannelDomainAndStatus.edit.domain'),
  });

  const initPageData = (type: RequestType) => {
    setLoading(true);
    request_domainsList(salesChannelUuid).then((res: any) => {
      const {
        domains = [],
        missingPageRedirectionSetting: {
          uuid = '',
          missingPageRedirections = [],
        } = {},
        customRedirectionSetting,
        sisterSalesChannelSetting,
      } = res;
      const _redirectSettingUuid = get(customRedirectionSetting, 'uuid');
      const customRedirections = (
        get(customRedirectionSetting, 'customRedirections') ||
        [
          // { _uuid: 1 },
          // { _uuid: 2 },
        ]
      ).map((i) => {
        if (i._uuid) {
          return i;
        } else {
          return { ...i, _uuid: randomNumber() };
        }
      });
      setRedirectSettingUuid(_redirectSettingUuid);
      setSisterSalesChannelList(
        get(sisterSalesChannelSetting, 'availableSalesChannels'),
      );
      if (type == RequestType.All) {
        redirectForm.setFieldsValue({ customRedirections });
        form.setFieldsValue({
          domains,
          missingPageRedirections,
        });
        setFormData({
          domains,
          missingPageRedirections,
        });
        SisterSalesChannelForm.setFieldsValue({
          ...res.sisterSalesChannelSetting,
        });
      } else {
        form.setFieldsValue({ domains });
        redirectForm.setFieldsValue({ customRedirections });
        SisterSalesChannelForm.setFieldsValue({
          sisterSalesChannelSetting,
        });
      }

      // setFormData({ domains, missingPageRedirections });
      setMissingPageRedirectionSettingUuid(uuid);
      setLoading(false);
    });
  };

  const onFinish = (values) => {
    delete values.domains;
    values.uuid = missingPageRedirectionSettingUuid;
    values.salesChannelUuid = salesChannelUuid;
    save_missingPageRedirection(values).then((data) => {
      setHasModified(false);
    });
  };
  const onGoBackClick = () => {
    history.push(`/salesChannel/settings/${salesChannelUuid}`);
  };

  useEffect(() => {
    if (view_domain_and_status) {
      initPageData(RequestType.All);
    } else {
      setLoading(false);
    }
  }, []);

  const handleOnSubmitRedirection = (e) => {
    const data = {
      uuid: redirectSettingUuid,
      salesChannelUuid,
      ...(e || {}),
    };
    save_redirection(data).then((res) => {
      setIsEditing(false);
    });
  };

  const handleOnSisterSalesChannelSetting = async (e) => {
    const data = {
      salesChannelUuid: salesChannelUuid,
      ...e,
    };
    await save_websitemode(data).then(() => {
      dispatch(fetchSalesChannel({ salesChannelUuid }));
      msg.success('saved successfully!');
    });
  };

  return (
    <Skeleton loading={loading || breadCrumbLoading} active>
      <RouteBlock
        onConfirm={(f) => f()}
        okText={getI18nFromGeneral('general.commonHeader.discard_text')}
        active={hasModified}
        title={getI18nFromGeneral('general.commonHeader.discard_header')}
        content={getI18nFromGeneral('general.commonHeader.discard_content')}
      />
      <CommonHeader
        breadcrumbData={breadcrumbData}
        onGoBackClick={onGoBackClick}
      />
      <Form
        name='domainList'
        form={form}
        className={css.formClass}
        initialValues={formData}
        onFinish={onFinish}
        onValuesChange={(e, a) => {
          setHasModified(true);
          setFormData(a);
        }}>
        <Domains
          initPageData={initPageData}
          disabled={!edit_domain_and_status}
        />
        <MissingPageRedirection
          hasModified={hasModified}
          setHasModified={setHasModified}
          form={form}
          disabled={!edit_domain_and_status}
        />
      </Form>
      <Form
        className={css.formClass}
        form={redirectForm}
        onFinish={handleOnSubmitRedirection}
        onValuesChange={(e, a) => {
          setHasModified(true);
        }}>
        <Redirection
          isEditing={isEditing}
          setIsEditing={setIsEditing}
          form={redirectForm}
          setHasModified={setHasModified}
          currentDomain={currentDomain}
          salesChannelUuid={salesChannelUuid}
        />
      </Form>
      <Form
        className={css.formClass}
        form={SisterSalesChannelForm}
        onFinish={handleOnSisterSalesChannelSetting}>
        <WebsiteMode
          form={SisterSalesChannelForm}
          sisterSalesChannelList={sisterSalesChannelList}
        />
      </Form>
    </Skeleton>
  );
};

export default SalesChannelDomain;
